import { Pref } from '~/generated/graphql'
type Prefecture = {
  readonly id: number
  readonly en: string
  readonly jp: string
}

export const PREFECTURES: ReadonlyArray<Prefecture> = [
  // 東京だけ先頭に、他はid昇順
  {
    id: 13,
    en: 'Tokyo',
    jp: '東京都',
  },
  {
    id: 1,
    en: 'Hokkaido',
    jp: '北海道',
  },
  {
    id: 2,
    en: 'Aomori',
    jp: '青森県',
  },
  {
    id: 3,
    en: 'Iwate',
    jp: '岩手県',
  },
  {
    id: 4,
    en: 'Miyagi',
    jp: '宮城県',
  },
  {
    id: 5,
    en: 'Akita',
    jp: '秋田県',
  },
  {
    id: 6,
    en: 'Yamagata',
    jp: '山形県',
  },
  {
    id: 7,
    en: 'Fukushima',
    jp: '福島県',
  },
  {
    id: 8,
    en: 'Ibaraki',
    jp: '茨城県',
  },
  {
    id: 9,
    en: 'Tochigi',
    jp: '栃木県',
  },
  {
    id: 10,
    en: 'Gunma',
    jp: '群馬県',
  },
  {
    id: 11,
    en: 'Saitama',
    jp: '埼玉県',
  },
  {
    id: 12,
    en: 'Chiba',
    jp: '千葉県',
  },
  {
    id: 14,
    en: 'Kanagawa',
    jp: '神奈川県',
  },
  {
    id: 15,
    en: 'Niigata',
    jp: '新潟県',
  },
  {
    id: 16,
    en: 'Toyama',
    jp: '富山県',
  },
  {
    id: 17,
    en: 'Ishikawa',
    jp: '石川県',
  },
  {
    id: 18,
    en: 'Fukui',
    jp: '福井県',
  },
  {
    id: 19,
    en: 'Yamanashi',
    jp: '山梨県',
  },
  {
    id: 20,
    en: 'Nagano',
    jp: '長野県',
  },
  {
    id: 21,
    en: 'Gifu',
    jp: '岐阜県',
  },
  {
    id: 22,
    en: 'Shizuoka',
    jp: '静岡県',
  },
  {
    id: 23,
    en: 'Aichi',
    jp: '愛知県',
  },
  {
    id: 24,
    en: 'Mie',
    jp: '三重県',
  },
  {
    id: 25,
    en: 'Shiga',
    jp: '滋賀県',
  },
  {
    id: 26,
    en: 'Kyoto',
    jp: '京都府',
  },
  {
    id: 27,
    en: 'Osaka',
    jp: '大阪府',
  },
  {
    id: 28,
    en: 'Hyogo',
    jp: '兵庫県',
  },
  {
    id: 29,
    en: 'Nara',
    jp: '奈良県',
  },
  {
    id: 30,
    en: 'Wakayama',
    jp: '和歌山県',
  },
  {
    id: 31,
    en: 'Tottori',
    jp: '鳥取県',
  },
  {
    id: 32,
    en: 'Shimane',
    jp: '島根県',
  },
  {
    id: 33,
    en: 'Okayama',
    jp: '岡山県',
  },
  {
    id: 34,
    en: 'Hiroshima',
    jp: '広島県',
  },
  {
    id: 35,
    en: 'Yamaguchi',
    jp: '山口県',
  },
  {
    id: 36,
    en: 'Tokushima',
    jp: '徳島県',
  },
  {
    id: 37,
    en: 'Kagawa',
    jp: '香川県',
  },
  {
    id: 38,
    en: 'Ehime',
    jp: '愛媛県',
  },
  {
    id: 39,
    en: 'Kochi',
    jp: '高知県',
  },
  {
    id: 40,
    en: 'Fukuoka',
    jp: '福岡県',
  },
  {
    id: 41,
    en: 'Saga',
    jp: '佐賀県',
  },
  {
    id: 42,
    en: 'Nagasaki',
    jp: '長崎県',
  },
  {
    id: 43,
    en: 'Kumamoto',
    jp: '熊本県',
  },
  {
    id: 44,
    en: 'Oita',
    jp: '大分県',
  },
  {
    id: 45,
    en: 'Miyazaki',
    jp: '宮崎県',
  },
  {
    id: 46,
    en: 'Kagoshima',
    jp: '鹿児島県',
  },
  {
    id: 47,
    en: 'Okinawa',
    jp: '沖縄県',
  },
] as const

type Prefecture_ = {
  readonly id: number
  readonly en: Pref
  readonly jp: string
}

// toridori-marketing-apiに移行が終わったら、PREFECTURES_を使う
export const PREFECTURES_: ReadonlyArray<Prefecture_> = [
  {
    id: 13,
    en: Pref.Tokyo,
    jp: '東京都',
  },
  {
    id: 1,
    en: Pref.Hokkaido,
    jp: '北海道',
  },
  {
    id: 2,
    en: Pref.Aomori,
    jp: '青森県',
  },
  {
    id: 3,
    en: Pref.Iwate,
    jp: '岩手県',
  },
  {
    id: 4,
    en: Pref.Miyagi,
    jp: '宮城県',
  },
  {
    id: 5,
    en: Pref.Akita,
    jp: '秋田県',
  },
  {
    id: 6,
    en: Pref.Yamagata,
    jp: '山形県',
  },
  {
    id: 7,
    en: Pref.Fukushima,
    jp: '福島県',
  },
  {
    id: 8,
    en: Pref.Ibaraki,
    jp: '茨城県',
  },
  {
    id: 9,
    en: Pref.Tochigi,
    jp: '栃木県',
  },
  {
    id: 10,
    en: Pref.Gunma,
    jp: '群馬県',
  },
  {
    id: 11,
    en: Pref.Saitama,
    jp: '埼玉県',
  },
  {
    id: 12,
    en: Pref.Chiba,
    jp: '千葉県',
  },
  {
    id: 14,
    en: Pref.Kanagawa,
    jp: '神奈川県',
  },
  {
    id: 15,
    en: Pref.Niigata,
    jp: '新潟県',
  },
  {
    id: 16,
    en: Pref.Toyama,
    jp: '富山県',
  },
  {
    id: 17,
    en: Pref.Ishikawa,
    jp: '石川県',
  },
  {
    id: 18,
    en: Pref.Fukui,
    jp: '福井県',
  },
  {
    id: 19,
    en: Pref.Yamanashi,
    jp: '山梨県',
  },
  {
    id: 20,
    en: Pref.Nagano,
    jp: '長野県',
  },
  {
    id: 21,
    en: Pref.Gifu,
    jp: '岐阜県',
  },
  {
    id: 22,
    en: Pref.Shizuoka,
    jp: '静岡県',
  },
  {
    id: 23,
    en: Pref.Aichi,
    jp: '愛知県',
  },
  {
    id: 24,
    en: Pref.Mie,
    jp: '三重県',
  },
  {
    id: 25,
    en: Pref.Shiga,
    jp: '滋賀県',
  },
  {
    id: 26,
    en: Pref.Kyoto,
    jp: '京都府',
  },
  {
    id: 27,
    en: Pref.Osaka,
    jp: '大阪府',
  },
  {
    id: 28,
    en: Pref.Hyogo,
    jp: '兵庫県',
  },
  {
    id: 29,
    en: Pref.Nara,
    jp: '奈良県',
  },
  {
    id: 30,
    en: Pref.Wakayama,
    jp: '和歌山県',
  },
  {
    id: 31,
    en: Pref.Tottori,
    jp: '鳥取県',
  },
  {
    id: 32,
    en: Pref.Shimane,
    jp: '島根県',
  },
  {
    id: 33,
    en: Pref.Okayama,
    jp: '岡山県',
  },
  {
    id: 34,
    en: Pref.Hiroshima,
    jp: '広島県',
  },
  {
    id: 35,
    en: Pref.Yamaguchi,
    jp: '山口県',
  },
  {
    id: 36,
    en: Pref.Tokushima,
    jp: '徳島県',
  },
  {
    id: 37,
    en: Pref.Kagawa,
    jp: '香川県',
  },
  {
    id: 38,
    en: Pref.Ehime,
    jp: '愛媛県',
  },
  {
    id: 39,
    en: Pref.Kochi,
    jp: '高知県',
  },
  {
    id: 40,
    en: Pref.Fukuoka,
    jp: '福岡県',
  },
  {
    id: 41,
    en: Pref.Saga,
    jp: '佐賀県',
  },
  {
    id: 42,
    en: Pref.Nagasaki,
    jp: '長崎県',
  },
  {
    id: 43,
    en: Pref.Kumamoto,
    jp: '熊本県',
  },
  {
    id: 44,
    en: Pref.Oita,
    jp: '大分県',
  },
  {
    id: 45,
    en: Pref.Miyazaki,
    jp: '宮崎県',
  },
  {
    id: 46,
    en: Pref.Kagoshima,
    jp: '鹿児島県',
  },
  {
    id: 47,
    en: Pref.Okinawa,
    jp: '沖縄県',
  },
] as const

export const getPrefectureNameJpById = (id: number) => PREFECTURES.find((pref) => pref.id === id)?.jp || null
export const getPrefectureIdByNameEn = (en: string) => PREFECTURES.find((pref) => pref.en === en)?.id || null
export const getPrefectureNameJpByNameEn = (en: string) => PREFECTURES.find((pref) => pref.en === en)?.jp || null

// 以下はPREFECTURESではなくPREFECTURES_から取得する
export const getPrefectureNameJpByPref = (pref: Pref) =>
  PREFECTURES_.find((prefectures) => prefectures.en === pref)?.jp || null
export const getPrefectureNameEnById = (id: number) => PREFECTURES_.find((pref) => pref.id === id)?.en || null
